<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="group">
  @switch (model.inputType) {
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_PASSWORD) {
      <p-input-password
        [label]="model.label ?? undefined"
        [toggle]="true"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [description]="model.hint"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        [autoComplete]="model.autoComplete"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [autoFocus]="model.autoFocus"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [id]="id"
        [value]="group.get(model.id)?.value ?? ''"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="$any(model.pattern)"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [tabindex]="safeTabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </p-input-password>
    }
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_DATE) {
      <p-input-date
        [label]="model.label ?? undefined"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [description]="model.hint"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        [autoComplete]="model.autoComplete"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [autoFocus]="model.autoFocus"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [id]="id"
        [value]="group.get(model.id)?.value ?? ''"
        [max]="model.maxLength?.toString()"
        [min]="model.minLength?.toString()"
        [name]="model.name"
        [pattern]="$any(model.pattern)"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [tabindex]="safeTabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </p-input-date>
    }
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_EMAIL) {
      <p-input-email
        [label]="model.label ?? undefined"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [description]="model.hint"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        [autoComplete]="model.autoComplete"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [autoFocus]="model.autoFocus"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [id]="id"
        [value]="group.get(model.id)?.value ?? ''"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="$any(model.pattern)"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [tabindex]="safeTabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </p-input-email>
    }
    @case (DYNAMIC_FORM_CONTROL_INPUT_TYPE_TEL) {
      <p-input-tel
        [label]="model.label ?? undefined"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [description]="model.hint"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        [autoComplete]="model.autoComplete"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [autoFocus]="model.autoFocus"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [id]="id"
        [value]="group.get(model.id)?.value ?? ''"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="$any(model.pattern)"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [tabindex]="safeTabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </p-input-tel>
    }
    @default {
      <p-input-text
        [label]="model.label ?? undefined"
        [state]="!!showErrorMessages ? 'error' : 'none'"
        [message]="errorMessages[0]"
        [description]="model.hint"
        [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
        [autoComplete]="model.autoComplete"
        [attr.accept]="model.accept"
        [attr.max]="model.max"
        [attr.min]="model.min"
        [attr.multiple]="model.multiple"
        [attr.step]="model.step"
        [autoFocus]="model.autoFocus"
        [dynamicList]="model.listId"
        [formControlName]="model.id"
        [id]="id"
        [value]="group.get(model.id)?.value ?? ''"
        [maxLength]="model.maxLength ?? undefined"
        [minLength]="model.minLength ?? undefined"
        [name]="model.name"
        [pattern]="$any(model.pattern)"
        [readOnly]="model.readOnly"
        [required]="model.required"
        [spellCheck]="model.spellCheck"
        [tabindex]="safeTabIndex"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
      >
      </p-input-text>
    }
  }
  <ng-template #strengthMeterViewContainerRef></ng-template>
</div>
